module.exports = __webpack_public_path__ + "img/logo.51fc510f.png";